module.exports = __webpack_public_path__ + "static/img/0.2b33852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/0.png
// module id = ce0l
// module chunks = 2